// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.circle::after {
  content: "";
  box-sizing: border-box;
  width: 40px;
  height: 40px;
  position: absolute;
  top: calc(50% - 20px);
  left: calc(50% - 20px);
  border-radius: 50%;
}

.circle.smooth::after {
  border-top: 4px solid rgb(255, 255, 255);
  border-left: 4px solid rgb(255, 255, 255);
  border-right: 4px solid rgba(255, 255, 255, 0);
  animation: spinner 0.6s linear infinite;
}

.circle.material::after {
  border-top: 4px solid rgb(233, 233, 233);
  border-left: 4px solid rgb(233, 233, 233);
  border-bottom: 4px solid rgb(233, 233, 233);
  border-right: 4px solid rgba(255, 255, 255, 0);
  animation: spinner 0.6s linear infinite;
}

.circle.pulse::after {
  background-color: rgb(255, 255, 255);
  animation: pulse 1s ease-in-out infinite;
}

.circle.grow-pulse::after {
  background-color: rgb(255, 255, 255);
  animation: grow-pulse 1.5s ease-out infinite;
}

@keyframes spinner {
  to {
    transform: rotate(360deg);
  }
}
@keyframes pulse {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes grow-pulse {
  0% {
    transform: scale(0.1);
    opacity: 0;
  }
  30% {
    opacity: 0.5;
  }
  60% {
    transform: scale(1.2);
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/shared/spinner/spinner.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;AACF;;AAEA;EACE,wCAAA;EACA,yCAAA;EACA,8CAAA;EACA,uCAAA;AACF;;AAEA;EACE,wCAAA;EACA,yCAAA;EACA,2CAAA;EACA,8CAAA;EACA,uCAAA;AACF;;AAEA;EACE,oCAAA;EACA,wCAAA;AACF;;AAEA;EACE,oCAAA;EACA,4CAAA;AACF;;AAEA;EACE;IACE,yBAAA;EACF;AACF;AAEA;EACE;IACE,UAAA;EAAF;EAEA;IACE,UAAA;EAAF;EAEA;IACE,UAAA;EAAF;AACF;AAGA;EACE;IACE,qBAAA;IACA,UAAA;EADF;EAGA;IACE,YAAA;EADF;EAGA;IACE,qBAAA;IACA,UAAA;EADF;EAGA;IACE,UAAA;EADF;AACF","sourcesContent":[".circle::after {\n  content: '';\n  box-sizing: border-box;\n  width: 40px;\n  height: 40px;\n  position: absolute;\n  top: calc(50% - 20px);\n  left: calc(50% - 20px);\n  border-radius: 50%;\n}\n\n.circle.smooth::after {\n  border-top: 4px solid rgba(255, 255, 255, 1);\n  border-left: 4px solid rgba(255, 255, 255, 1);\n  border-right: 4px solid rgba(255, 255, 255, 0);\n  animation: spinner 0.6s linear infinite;\n}\n\n.circle.material::after {\n  border-top: 4px solid rgba(233, 233, 233, 1);\n  border-left: 4px solid rgba(233, 233, 233, 1);\n  border-bottom: 4px solid rgba(233, 233, 233, 1);\n  border-right: 4px solid rgba(255, 255, 255, 0);\n  animation: spinner 0.6s linear infinite;\n}\n\n.circle.pulse::after {\n  background-color: rgba(255, 255, 255, 1);\n  animation: pulse 1s ease-in-out infinite;\n}\n\n.circle.grow-pulse::after {\n  background-color: rgba(255, 255, 255, 1);\n  animation: grow-pulse 1.5s ease-out infinite;\n}\n\n@keyframes spinner {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes pulse {\n  0% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n@keyframes grow-pulse {\n  0% {\n    transform: scale(0.1);\n    opacity: 0;\n  }\n  30% {\n    opacity: 0.5;\n  }\n  60% {\n    transform: scale(1.2);\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
